import { useModal, useUserRoleCapabilities } from '@src/stores';
import { useNavigate } from '@tanstack/react-router';
import { useAuth } from '@hooks';
import Card from '@components/card/card';
import { ModalTabContainer } from '@components/modal';
import SectionHeader from '@components/section-header/SectionHeader';
import NewApplicationModal from '@src/app-pages/Home/components/modals/NewApplication';
import SectionCard from '@src/app-components/section-card/SectionCard';
import PermitProcessQuestionnaire from './PermitProcessQuestionnaire';
import '../../resources.scss';

const PermitProcessGuide = () => {
  const navigate = useNavigate();
  const { openModal } = useModal();
  const { login, isAuthenticated } = useAuth();
  const canCreateRequest = useUserRoleCapabilities((state) => state.roleCapabilities.createRequest);

  const handleLink = async () => {
    sessionStorage.setItem('ResourcesModuleSession', true);
    if (!isAuthenticated) {
      login();
      return;
    }
    await navigate({ to: '/home' });
    const resourcesModuleSession = sessionStorage.getItem('ResourcesModuleSession');
    resourcesModuleSession && openModal(NewApplicationModal);
    sessionStorage.removeItem('ResourcesModuleSession');
  };

  return (
    <div>
      <section id='guide-tool-id'>
        <SectionHeader>Permit Process Guide</SectionHeader>
        <p>
          The Regulatory Permit Process Questionnaire helps you understand the permitting process by asking a series of
          questions about your project. Based on your responses, you will be directed to relevant information and
          guidance on the type of request that may apply.
        </p>
        <Card>
          <Card.Body>
            <ModalTabContainer
              tabs={[
                {
                  content: <PermitProcessQuestionnaire />,
                },
              ]}
              hideLastBtn
            />
          </Card.Body>
        </Card>
      </section>
      <section id='next-steps-id' className='margin-top-3'>
        <SectionHeader>What are my next steps?</SectionHeader>
        <div className='row margin-top-3'>
          <div className='col-lg-6 col-md-6 col-xs-12 margin-top-1'>
            <SectionCard
              title='Create a New Request'
              content={`If you're ready to start a new request, click here to ${
                isAuthenticated ? 'start a new request' : 'sign in'
              }.`}
              onClick={handleLink}
              buttonText={isAuthenticated ? 'Start a New Request' : 'Sign In'}
              buttonTitle={isAuthenticated ? 'Start a New Request' : 'Sign In'}
              isDisabled={!canCreateRequest && isAuthenticated}
            />
          </div>
          <div className='col-lg-6 col-md-6 col-xs-12 margin-top-1'>
            <SectionCard
              title='Need Further Assistance'
              content='Locate your local USACE Regulatory office for further assistance.'
              url='https://regulatory.ops.usace.army.mil/offices/'
              buttonText='Office Locator'
              buttonTitle='LearnMore'
              external
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default PermitProcessGuide;
